import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import '../styles/BlogsPage.css';

export default function TermsPage() {
  return (
    <div className="blogs-page">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg blogs-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/sidebar-logo.png" alt="MeetingPoint Logo" loading="lazy" />
          </Link>
          <div className="d-flex align-items-center gap-3">
            <Link to="/blogs" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-newspaper me-2"></i>Blog
            </Link>
            <Link to="/" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-arrow-left me-2"></i>Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Header */}
      <header className="blog-detail-hero">
        <div className="container">
          <h1 className="blog-detail-title">Terms of Service</h1>
          <p className="blog-detail-excerpt">Effective Date: March 25, 2026</p>
        </div>
      </header>

      {/* Content */}
      <article className="container blog-detail-content">
        <div className="blog-detail-body privacy-body">
          <p>
            Welcome to MeetingPoint.chat (the "Service"). By accessing or using our website and peer-to-peer communication tools, you agree to be bound by the following Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>

          <h3>1. Description of Service</h3>
          <p>MeetingPoint.chat provides a browser-based, peer-to-peer (P2P) communication interface. We facilitate the "signaling" required for two browsers to connect directly to one another. We do not provide accounts, storage, or message logging.</p>

          <h3>2. Eligibility</h3>
          <p>You must be at least 18 years of age to use this Service. By using MeetingPoint.chat, you represent and warrant that you meet this age requirement and have the legal capacity to enter into this agreement.</p>

          <h3>3. User Conduct and Responsibilities</h3>
          <p>You are solely responsible for your conduct and any data (text, images, audio, video) transmitted during your P2P sessions. You agree not to use the Service for:</p>
          <ul>
            <li>Any illegal or unauthorized purpose.</li>
            <li>Harassment, abuse, or stalking of other individuals.</li>
            <li>Transmitting "junk mail," "spam," or any other form of unauthorized solicitation.</li>
            <li>Impersonating any person or entity.</li>
            <li>Attempting to disrupt or interfere with the Service's signaling servers or infrastructure.</li>
          </ul>

          <h3>4. No-Data & Technical Limitations</h3>
          <p>Because MeetingPoint.chat is a P2P service:</p>
          <ul>
            <li><strong>No Recovery:</strong> Since we do not store your data, we cannot recover lost conversations, files, or connection history.</li>
            <li><strong>Connectivity:</strong> Connection quality depends entirely on the internet speed and hardware of the peers involved. We do not guarantee uninterrupted service.</li>
            <li><strong>IP Visibility:</strong> In a P2P connection, your IP address is inherently visible to the peer you are connecting with. Use of the Service constitutes your acknowledgment of this technical reality.</li>
          </ul>

          <h3>5. Advertisements and Third-Party Links</h3>
          <p>To provide this Service free of charge, we display advertisements via Google AdSense. We do not endorse or assume responsibility for any third-party products or services advertised on our site. Your interactions with advertisers are solely between you and the third party.</p>

          <h3>6. Disclaimer of Warranties</h3>
          <p>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE SECURE, ERROR-FREE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>

          <h3>7. Limitation of Liability</h3>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, MEETINGPOINT.CHAT AND ITS OPERATORS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF THE SERVICE OR INTERACTIONS WITH OTHER USERS.</p>

          <h3>8. Modifications to Terms</h3>
          <p>We reserve the right to modify these Terms at any time. Your continued use of the Service following any changes constitutes your acceptance of the new Terms.</p>

          <h3>9. Contact</h3>
          <p>For questions regarding these Terms, please contact us at: <a href="mailto:admin@meetingpoint.chat" className="text-decoration-underline">admin@meetingpoint.chat</a></p>
        </div>
      </article>

      {/* Footer */}
      <footer className="blogs-footer">
        <div className="container text-center">
          <p className="mb-1">&copy; {new Date().getFullYear()} MeetingPoint. All rights reserved.</p>
          <div className="d-flex justify-content-center gap-3 mt-2 flex-wrap">
            <Link to="/" className="text-muted">Home</Link>
            <Link to="/about" className="text-muted">About</Link>
            <Link to="/blogs" className="text-muted">Blog</Link>
            <Link to="/faq" className="text-muted">FAQ</Link>
            <Link to="/contact" className="text-muted">Contact</Link>
            <Link to="/privacy" className="text-muted">Privacy Policy</Link>
            <Link to="/disclaimer" className="text-muted">Disclaimer</Link>
          </div>
        </div>
      </footer>
      <ScrollToTop />
    </div>
  );
}
